module.exports = __webpack_public_path__ + "img/new-year-cap.b97fb35e.svg";